<template>
  <div>
    <base-header class="pb-6" />
    <b-container fluid class="mt--6 max-width">
      <b-card no-body>

        <validation-observer v-slot="{handleSubmit}" ref="formValidator">
          <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">

            <card-header title="Edit Group">
              <base-button type="white" size="sm" @click="onCancel">Cancel</base-button>
              <base-button type="success" size="sm" native-type="submit" :loading="isLoading">Save</base-button>
            </card-header>

            <b-card-body>
              <b-row>
                <b-col md="6">
                  <base-input label="Name" name="name" v-model="form.name" :rules="{required: true, apiname: true}" />
                </b-col>
                <b-col md="6">
                  <base-input label="Description" name="description" v-model="form.description"/>
                </b-col>
              </b-row>

              <b-row>
                <b-col md="6">
                  <fieldset>
                    <label class="form-control-label">Sites <span class="font-weight-light">Optional</span></label>
                    <sites-select :selected.sync="form.site"/>
                  </fieldset>
                </b-col>

                <!--b-col md="6">
                  <fieldset>
                    <label class="form-control-label">Kiosk <span class="font-weight-light">Optional</span></label>
                    <kiosk-select :selected.sync="form.kiosk"/>
                  </fieldset>
                </b-col>-->
              </b-row>

              <!--b-row class="mt-4">
                <b-col md="6">
                  <label class="form-control-label">GPS Location within site <span class="font-weight-light">Optional and only editable if site is set</span></label>
                </b-col>
                <b-col md="3">
                  <label class="form-control-label">Floor Level</label>
                </b-col>
                <b-col md="3">
                  <label class="form-control-label">Capacity</label>
                </b-col>
              </b-row>

              <b-row>

                <b-col md="3">
                  <base-input
                      name="latitude"
                      placeholder="Latitude"
                      v-model="form.latitude"
                      :rules="{ latitude: !isSiteSelected, required: !isSiteSelected }"
                      :disabled="isSiteSelected"
                  />
                </b-col>

                <b-col md="3">
                  <base-input
                      name="longitude"
                      placeholder="Longitude"
                      v-model="form.longitude"
                      :rules="{ longitude: !isSiteSelected, required: !isSiteSelected }"
                      :disabled="isSiteSelected"
                  />
                </b-col>

                <b-col md="3">
                  <base-input
                      name="floor"
                      placeholder="Int"
                      v-model="form.floor"
                      :rules="{ numeric: !isSiteSelected }"
                      :disabled="isSiteSelected"
                  />
                </b-col>

                <b-col md="3">
                  <base-input
                      name="capacity"
                      v-model="form.capacity"
                      :rules="{ required: true, numeric: true, min_value: 1, max_value: 1000 }"
                  />
                </b-col>

              </b-row>-->

              <b-row>

                <b-col md="6">
                  <label class="form-control-label">Alloc</label>

                  <base-input :rules="{json: true}">
                    <textarea class="form-control font-mono" rows="6" v-model="form.allocinfo" />
                  </base-input>

                  <file-loader
                      initialLabel="Select JSON file"
                      accept=".json"
                      :maxSize="1000000"
                      :content.sync="form.allocinfo" />
                </b-col>

                <b-col md="6">
                  <label class="form-control-label">Global Info</label>

                  <base-input :rules="{json: true}">
                    <textarea class="form-control font-mono" rows="6" v-model="form.globalinfo" />
                  </base-input>

                  <file-loader
                      class="mb-1"
                      initialLabel="Select JSON file"
                      accept=".json"
                      :maxSize="100000"
                      :content.sync="form.globalinfo" />
                </b-col>
                <b-col md="6">
                  <label class="form-control-label">Unalloc Info </label>

                  <base-input :rules="{json: true}">
                    <textarea class="form-control font-mono" rows="6" v-model="form.unallocinfo" />
                  </base-input>

                  <file-loader
                      class="mb-1"
                      initialLabel="Select JSON file"
                      accept=".json"
                      :maxSize="100000"
                      :content.sync="form.unallocinfo" />
                </b-col>
              </b-row>

              <b-row>


                <!--b-col md="12" class="mt-4">
                  <label class="form-control-label">X509 Certificate <span class="font-weight-light">Optional</span></label>

                  <textarea class="form-control mb-2 font-mono" rows="2" v-model="form.cert" readonly></textarea>

                  <file-loader
                      initialLabel="Select Certificate file"
                      accept=".pem,.pub"
                      :maxSize="100000"
                      :content.sync="form.cert" />
                </b-col>-->
              </b-row>

            </b-card-body>

          </b-form>
        </validation-observer>
 <b-card-body>
  <b-row>
    <b-col>
      <base-button 
        type="primary" 
        size="sm" 
        @click="showResourcesModal"
      >
        <i class="fas fa-folder-open mr-1"></i> Manage Resources
      </base-button>
       
    </b-col>
  </b-row>
</b-card-body>
      </b-card>
    </b-container>
   
  <upload-modals
  ref="uploadModals"
  title="Group"
  :id="form.name"
  :site-id="form.site"
  :existing-files="existingFiles"
  :existing-firmware="existingFirmware"
  :existing-icons="existingIcons"
  @upload-file="onUploadFile"
  @upload-firmware="onUploadFirmware"
  @upload-icon="onUploadIcon"
  @delete-file="confirmDeleteFile"
  @delete-firmware="confirmDeleteFirmware"
  @delete-icon="confirmDeleteIcon"
  @fetch-files="fetchGroupFiles"
  @fetch-firmware="listGroupFirmware"
  @fetch-icons="fetchGroupIcons"
    @firmware-tab-activated="syncGitlab" 
/>

  </div>
</template>



<script>
import {Routes} from "@/router";
import {Action} from "@/store/actions";
import {mapGetters} from "vuex";
import SitesSelect from "@/views/components/SitesSelect";
import KioskSelect from "@/views/components/KioskSelect";
import FileLoader from "@/views/components/FileLoader";
import {MapServiceDispenser} from "@/services/map.service";
import UploadModals from "@/views/components/UploadModals";

export default {
  name: "DispenserEdit",
  components: {
    SitesSelect,
    KioskSelect,
    FileLoader,
    UploadModals
  },
  data() {
    return {
      form: {
        name: '',
        description: '',
        site: null,
        kiosk: null,
        globalinfo: undefined,
        allocinfo: undefined,
        unallocinfo: undefined,
        latitude: '',
        longitude: '',
        floor: undefined,
        capacity: '',
        wifiap: '',
        networkInfo: undefined,
        config: undefined,
        cert: undefined,
        devicePath: "",
        uploading: false,
       

      },
      fileToUpload: null,
        syncingGitlab: false,
      accept: '*/*', // Accept all file types
      maxSize: 10000000, // 10MB max size
   
      activeDispenser: null,
      isLoading: false,
      //showFileModal: false,
    
      existingFiles: [],
      fileFields: [
        { key: 'filename', label: 'File Name' },
        { key: 'file_device_path', label: 'Device Path' },
        { key: 'upload_date', label: 'Upload Date' },
        { key: 'size_bytes', label: 'Size', formatter: value => this.formatFileSize(value) },
        { key: 'actions', label: 'Actions' }
      ],
      activeTab: 0,
            //showFirmwareModal: false,
      existingFirmware: [],
      firmwareFields: [
        { key: 'version', label: 'Version' },
        { key: 'device_type', label: 'Device Type' },
        { key: 'filename', label: 'File Name' },
        { key: 'release_date', label: 'Upload Date' },
        { key: 'actions', label: 'Actions' }
      ],
      firmwareFile: null,
      firmwareVersion: '',
      firmwareDescription: '',
      firmwareUploading: false,
      activeFirmwareTab: 0,
      deviceTypeOptions: [
      { value: 'CC1', text: 'CC1' },
      { value: 'CC2', text: 'CC2' }
    ],
      firmwareDeviceType: 'CC2',
        existingIcons: [],
      iconFields: [
        { key: 'filename', label: 'Original Name' },
        { key: 'converted_filename', label: 'Converted Name' },
        { key: 'format', label: 'Format' },
        { key: 'file_device_path', label: 'Device Path' },
        { key: 'upload_date', label: 'Upload Date' },
        { key: 'size_bytes', label: 'Size', formatter: value => this.formatFileSize(value) },
        { key: 'actions', label: 'Actions' }
      ]

    };
  },
   
  computed: {
    ...mapGetters(['dispenserByName']),
    isGroupSelected: function() {
      return this.form.site === null
    },
     canUploadFirmware() {
      return this.firmwareFile && 
             this.firmwareVersion && 
             this.firmwareDeviceType
    }
  },
  methods: {
    showResourcesModal() {
  this.$refs.uploadModals.openModal(0); // open Files tab
  // After the modal is fully shown (next tick), check which tab is active and sync if firmware
  this.$nextTick(() => {
    // Wait a tiny bit more for Bootstrap transitions
    setTimeout(() => {
      const activeTab = this.$refs.uploadModals.activeTab; // if the child exposes activeTab
      if (activeTab === 1) { // assuming firmware tab index is 1
        this.syncGitlab();
      }
    }, 200);
  });
}, 
async syncGitlab() {
  // Get entity from the loaded dispenser (same way listing works)
  const dispenser = this.dispenserByName(this.activeDispenser);
  const entity = dispenser?.entity;

  if (!entity) {
    this.$notify({ type: 'danger', title: 'Error', text: 'Entity not found in dispenser data.' });
    return;
  }

  this.syncingGitlab = true;
  try {
    const resp = await this.$http.post(`/tenant/${entity}/firmware/sync-gitlab?device_type=CC2`);
  
    await this.listGroupFirmware();  // refresh list
  } catch (e) {
    // error handling...
  } finally {
    this.syncingGitlab = false;
  }
},
     showFileModal() {
      this.$refs.uploadModals.showFilesModal();
    },
    
    showFirmwareModal() {
      this.$refs.uploadModals.showFirmwaresModal();
    },
    onCancel() {
      this.$router.push({name: Routes.dispenserList});
    },
    onSubmit() {
      this.isLoading = true
      const model = MapServiceDispenser.formToModel(this.form)
      this.$store.dispatch(Action.dispenser.save, {name: this.activeDispenser, data: model})
        .then(() => {
          this.$router.push({name: Routes.dispenserList})
        }).catch(error => {
          this.isLoading = false
          console.error(error)
        })
    },
        onFileLoaded(fileContent, fileName) {
      this.fileToUpload = {
        content: fileContent,
        name: fileName
      };
    },
    resetFileUpload() {
      this.activeTab = 0;
      this.fileToUpload = null;
      this.devicePath = "";
      this.uploading = false;
    },
    
    resetFirmwareUpload() {
      this.activeFirmwareTab = 0;
      this.resetFirmwareForm();
      this.firmwareUploading = false;
    },
    // In your Vue component
    async onUploadFile(fileData, callback) {
  try {
    const formData = new FormData();
    formData.append('file', new Blob([fileData.content]), fileData.name);
    formData.append('group_id', fileData.id);
    formData.append('site_id', fileData.siteId);
    formData.append('level', 'group');
    
    if (fileData.devicePath) {
      formData.append('file_device_path', fileData.devicePath);
    }
    
    await this.$store.dispatch(Action.dispenser.uploadGroupFile, formData);
    
    this.$notify({
      type: 'success',
      title: 'File Upload',
      text: 'File uploaded successfully!'
    });
    
    callback();
    this.fetchGroupFiles();
  } catch (error) {
    this.$notify({
      type: 'danger',
      title: 'File Upload Failed',
      text: error.response?.data?.message || 'Failed to upload file'
    });
    callback();
  }
},

    async fetchGroupFiles() {
      console.log("fetchGroupFiles called, groupId:", this.form.name, "siteId:", this.form.site);
        try {
          const siteId = this.form.site 
          const groupId= this.form.name;
         //console.log("Listing group files with:", { groupId, siteId });

          const response = await this.$store.dispatch(
            Action.dispenser.listGroupFiles, 
            {
              groupId: this.form.name,
              siteId: siteId
            }
          );
          this.existingFiles = response.files || [];
        } catch (error) {
          console.error("Failed to fetch Group files", error);
        }
    },
    
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
    },
    
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    
    confirmDeleteFile(file) {
      this.$bvModal.msgBoxConfirm(`Delete ${file.filename}? This cannot be undone.`, {
        title: 'Confirm Delete',
        okVariant: 'danger',
        okTitle: 'Delete',
        cancelTitle: 'Cancel',
        centered: true
      }).then(confirmed => {
        if (confirmed) {
          this.deleteFile(file);
        }
      });
    },
    async deleteFile(file) {
  try {
    await this.$store.dispatch(
      Action.dispenser.deleteGroupFile, 
      file.id
    );
     this.$notify({
          type: 'success',
          title: 'File Deleted',
          text: `${file.filename} was successfully removed`
        });
    await this.fetchGroupFiles(); // Refresh list
  } catch (error) {
    console.error("Failed to delete file", error);
  }
    },
    confirmDeleteAllFiles() {
    this.$bvModal.msgBoxConfirm(
      `Delete all ${this.existingFiles.length} files? This cannot be undone.`,
      {
        title: 'Confirm Delete All',
        okVariant: 'danger',
        okTitle: 'Delete All',
        cancelTitle: 'Cancel',
        centered: true
      }
    ).then(confirmed => {
      if (confirmed) {
        this.deleteAllFiles();
      }
    });
    },
  
    async deleteAllFiles() {
    try {
      await this.$store.dispatch(
        Action.dispenser.deleteAllGroupFiles, 
        this.form.name
      );
      
      this.$notify({
        type: 'success',
        title: 'Files Deleted',
        text: `All ${this.existingFiles.length} files were successfully removed`
      });
      
      this.existingFiles = [];
    } catch (error) {
      console.error("Failed to delete all files", error);
      this.$notify({
        type: 'danger',
        title: 'Delete Failed',
        text: 'Failed to delete all files'
      });
    }
    },
  
  
    onFirmwareFileLoaded(fileContent, fileName) {
      this.firmwareFile = {
        content: fileContent,
        name: fileName
      }
    },
    
    async onUploadFirmware(firmwareData, callback) {
  try {
    const formData = new FormData();
    formData.append('firmware_file', new Blob([firmwareData.content]), firmwareData.name);
    formData.append('version', firmwareData.version);
    formData.append('device_type', firmwareData.deviceType);
    formData.append('description', firmwareData.description);
    formData.append('level', 'group');
    formData.append('group_id', firmwareData.id);
    formData.append('site_id', firmwareData.siteId);

    await this.$store.dispatch(Action.dispenser.uploadGroupFirmware, formData);
    
    this.showNotification('Firmware uploaded successfully!', 'success');
    callback();
    this.listGroupFirmware();
  } catch (error) {
    this.showNotification('Firmware upload failed', 'danger', error);
    callback();
  }
},
    async listGroupFirmware() {
      try {
        const siteId = this.form.site 
        const groupId= this.form.name;
       //console.log("Listing group firmware with:", { groupId, siteId });

        const response = await this.$store.dispatch(
          Action.dispenser.listGroupFirmware, 
           {
              groupId: this.form.name,
              siteId: siteId,
               include_entity: true
            }
        );
        this.existingFirmware = response || [];
      } catch (error) {
        console.error("Failed to fetch Group firmware", error);
      }
    },
    
    confirmDeleteFirmware(firmware) {
      this.$bvModal.msgBoxConfirm(`Delete ${firmware.filename}? This cannot be undone.`, {
        title: 'Confirm Delete',
        okVariant: 'danger',
        okTitle: 'Delete',
        cancelTitle: 'Cancel',
        centered: true
      }).then(confirmed => {
        if (confirmed) {
          this.deleteFirmware(firmware);
        }
      });
    },
    
    async deleteFirmware(firmware) {
      try {
        const originalList = [...this.existingFirmware];
    
    // Optimistically remove the firmware from the list
    this.existingFirmware = this.existingFirmware.filter(fw => fw.id !== firmware.id);
        await this.$store.dispatch(
          Action.dispenser.deleteGroupFirmware, 
          firmware.id 
        );
          this.showNotification(
          `Firmware ${firmware.filename} (v${firmware.version}) deleted successfully!`,
          'success'
        );
        await this.listGroupFirmware();
      } catch (error) {
            this.existingFirmware = originalList;

         this.showNotification(
          'Firmware deletion failed', 
          'danger', 
          error
        );
        console.error("Failed to delete firmware", error);
      }
    },
    confirmDeleteAllFirmware() {
    this.$bvModal.msgBoxConfirm(
      `Delete all ${this.existingFirmware.length} firmware files? This cannot be undone.`,
      {
        title: 'Confirm Delete All',
        okVariant: 'danger',
        okTitle: 'Delete All',
        cancelTitle: 'Cancel',
        centered: true
      }
    ).then(confirmed => {
      if (confirmed) {
        this.deleteAllFirmware();
      }
    });
  },
  
    async deleteAllFirmware() {
    try {
      await this.$store.dispatch(
        Action.dispenser.deleteAllGroupFirmware, 
        {
          groupId: this.form.name,
          deviceType: 'cc2' // Default device type
        }
      );
      
      this.$notify({
        type: 'success',
        title: 'Firmware Deleted',
        text: `All ${this.existingFirmware.length} firmware files were successfully removed`
      });
      
      this.existingFirmware = [];
    } catch (error) {
      console.error("Failed to delete all firmware", error);
      this.$notify({
        type: 'danger',
        title: 'Delete Failed',
        text: 'Failed to delete all firmware'
      });
    }
    },
    resetFirmwareForm() {
      this.firmwareFile = null;
      this.firmwareVersion = '';
      this.firmwareDeviceType = '';
      this.firmwareDescription = '';
    },
    
    showNotification(message, type, error = null) {
      const text = error
        ? error.response?.data?.message || 'An unexpected error occurred'
        : message;
      
      this.$notify({
        type,
        title: type === 'success' ? 'Success' : 'Error',
        text
      });
    },



    showIconModal() {
      this.$refs.uploadModals.showIconsModal();
    },
    
    async onUploadIcon(iconData, callback) {
      try {
        const formData = new FormData();
        formData.append('file', new Blob([iconData.content]), iconData.name);
        formData.append('group_id', iconData.id);
        formData.append('site_id', iconData.siteId);
        formData.append('level', 'group');
        
        if (iconData.devicePath) {
          formData.append('file_device_path', iconData.devicePath);
        }
        
        if (iconData.description) {
          formData.append('description', iconData.description);
        }
        
        await this.$store.dispatch(Action.dispenser.uploadGroupIcon, formData);
        
        this.$notify({
          type: 'success',
          title: 'Icon Upload',
          text: 'Icon converted to PBM and uploaded successfully!'
        });
        
        callback();
        this.fetchGroupIcons();
      } catch (error) {
        this.$notify({
          type: 'danger',
          title: 'Icon Upload Failed',
          text: error.response?.data?.message || 'Failed to upload icon'
        });
        callback();
      }
    },
    
    async fetchGroupIcons() {
  try {
    const siteId = this.form.site;
    const groupId = this.form.name;
   //console.log("Fetching group icons with:", { groupId, siteId });
    
    // Call the store action
    const result = await this.$store.dispatch(
      Action.dispenser.listGroupIcons,
      {
        groupId: this.form.name,
        siteId: siteId
      }
    );
    
   //console.log("Store dispatch returned:", result);
   //console.log("Type of result:", typeof result);
   //console.log("Is array?", Array.isArray(result));
    
    // Handle different return structures
    if (Array.isArray(result)) {
      this.existingIcons = result;
    } else if (result && result.icons && Array.isArray(result.icons)) {
      this.existingIcons = result.icons;
    } else if (result && result.data && result.data.icons) {
      this.existingIcons = result.data.icons;
    } else {
      console.warn("Unexpected result structure:", result);
      this.existingIcons = [];
    }
    
   //console.log("Final icons array:", this.existingIcons);
    
  } catch (error) {
    console.error("Failed to fetch group icons", error);
    console.error("Error details:", error.response?.data);
    this.existingIcons = [];
  }
},
    
    confirmDeleteIcon(icon) {
      this.$bvModal.msgBoxConfirm(
        `Delete ${icon.filename}? This cannot be undone.`,
        {
          title: 'Confirm Delete',
          okVariant: 'danger',
          okTitle: 'Delete',
          cancelTitle: 'Cancel',
          centered: true
        }
      ).then(confirmed => {
        if (confirmed) {
          this.deleteIcon(icon);
        }
      });
    },
    
    async deleteIcon(icon) {
      try {
        await this.$store.dispatch(
          Action.dispenser.deleteGroupIcon,
          icon.id
        );
        
        this.$notify({
          type: 'success',
          title: 'Icon Deleted',
          text: `${icon.filename} was successfully removed`
        });
        
        await this.fetchGroupIcons();
      } catch (error) {
        console.error("Failed to delete icon", error);
        this.$notify({
          type: 'danger',
          title: 'Delete Failed',
          text: 'Failed to delete icon'
        });
      }
    },
    
    confirmDeleteAllIcons() {
      this.$bvModal.msgBoxConfirm(
        `Delete all ${this.existingIcons.length} icons? This cannot be undone.`,
        {
          title: 'Confirm Delete All',
          okVariant: 'danger',
          okTitle: 'Delete All',
          cancelTitle: 'Cancel',
          centered: true
        }
      ).then(confirmed => {
        if (confirmed) {
          this.deleteAllIcons();
        }
      });
    },
    
    async deleteAllIcons() {
      try {
        await this.$store.dispatch(
          Action.dispenser.deleteAllGroupIcons,
          this.form.name
        );
        
        this.$notify({
          type: 'success',
          title: 'Icons Deleted',
          text: `All ${this.existingIcons.length} icons were successfully removed`
        });
        
        this.existingIcons = [];
      } catch (error) {
        console.error("Failed to delete all icons", error);
        this.$notify({
          type: 'danger',
          title: 'Delete Failed',
          text: 'Failed to delete all icons'
        });
      }
    }

  },
  // ---------------------
  beforeMount() {
    const name = this.$route.params.name
    if(!name) { this.$router.back() }
    const dispenser = this.dispenserByName(name)
    if(!dispenser) { this.$router.back() }
    this.activeDispenser = name;
    this.form = MapServiceDispenser.modelToForm(dispenser, this.form)
  }
}
</script>

